export const AuthTypes = {
  signIn: "[Auth] SignIn",
  signOut: "[Auth] SignOut",
  nameChanged: "[Auth] NameChanged",
};
